'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'parallax', () => ({

			init() {
				const viewportHeight = window.innerHeight;
				const position       = this.$el.getBoundingClientRect().top;
				const image          = this.$el.querySelector( 'figure' );

				window.addEventListener( 'scroll', () => {

					if ( window.matchMedia( '( min-width: 62em )' ).matches ) {
						let scroll     = window.scrollY;
						let translateY = ( scroll - position ) / 3;

						if ( translateY < viewportHeight ) {
							if ( 0 < translateY ) translateY = 0;
							image.style.transform = `translateY( ${ translateY * -1 }px )`;
						}
					}
				});
			},
		}) );

	});
})();
